<form [formGroup]="form">
    <div class="row shadow title-list bg-white rounded">
        <div class="col-md-2 pl-5 pt-2">
            <h1 class="lblTitle-02">
                {{ 'rollCall.lblTitle' | translate }}
            </h1>
        </div>
        <div class="col-md-10">
            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-2">
                    <mat-form-field appearance="outline" class="search-field">
                        <mat-label>
                            {{ 'rollCall.filterSection.lblCreationDate' | translate }}
                        </mat-label>
                        <mat-date-range-input [rangePicker]="txtFechaAlta">
                            <input matStartDate placeholder="Fecha inicio" formControlName="dateStart">
                            <input matEndDate placeholder="Fecha fin" formControlName="dateEnd" id="txtDateEnd">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
                        <mat-date-range-picker #txtFechaAlta>
                        </mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="outline" class="search-field">
                        <mat-label>
                            {{ 'rollCall.filterSection.lblStatus' | translate }}
                        </mat-label>
                        <mat-select formControlName="status">
                            <mat-option *ngFor="let item of statusCatalog"
                                value="{{item.value}}">{{item.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4 mt-2">
                    <div class="btn-group">
                        <ng-container *ngIf="form.valid">
                            <button type="button" class="btn btn-primary w-120-px mr-3" (click)="setFilters()">
                                <i class="fas fa-search"></i>
                                {{ 'common.btnSearch' | translate }}
                            </button>
                        </ng-container>

                        <button type="button" class="btn btn-secondary flex-justif-alig-center w-100-px"
                            (click)="clearFilters()">
                            <i class="fas fa-times mr-1"></i>
                            {{ 'common.btnClear' | translate }}
                        </button>
                    </div>
                    <div class="btn-group ml-3">
                        <button type="button" class="btn btn-info-05" (click)="viewOtherFilters()">
                            <img class="" src="assets/images/icon/ico_busquedaAvanzada.png" alt="">
                            {{ 'rollCall.filterSection.lblAdvancedSearch' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row ml-3 pl-3 pr-5 mb-3 text-right">
        <div class="col-lg-10"></div>
        <div class="col-lg-2 ">
            <button type="button" class="btn btn-info-05" [disabled]="!form.valid" (click)="reportFilters()">
                <i class="fas fa-search"></i>
                {{ 'rollCall.filterSection.lblDownload' | translate }}
            </button>
        </div>
    </div>
</form>